import type { IconData } from '@stacksjs/iconify-core'

export const designDropper1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.335 7.62v1.52h1.53v1.52h1.52v1.53h3.05v-1.53h1.52V7.62h-1.52V6.09h1.52V4.57h1.52V1.52h-1.52V0h-3.05v1.52h-1.52v1.53h-1.52V1.52h-3.05v1.53h-1.53v3.04h1.53v1.53z\"/><path fill=\"currentColor\" d=\"M21.335 10.66h1.53v1.53h-1.53Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.53-4.57h1.53v1.52h-1.53Zm-3.04 6.09v-1.52h-1.53v1.52h-1.52v1.53h-1.52v1.52h-1.53v4.57h4.57v-1.52h1.53v-1.53h1.52v-1.52h1.52v-1.52h1.53v-1.53zm1.52-4.57h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.53h-1.52Zm-7.62 18.29h-3.05v1.52h-3.05V32h13.72v-1.53h-3.05v-1.52h-3.05v-1.52h-1.52zm0-6.1h1.52v3.05h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default designDropper1
